import React from 'react';

import { translate } from '~l10n/client';

import { SmallButton } from '~shared/components/buttons';
import { Container } from '~shared/components/Container';

interface Props {
  maxRows: number;
  setMaxRows: () => void;
  totalRows: number;
}

export function WorkspaceMembersTableIncrementMenu({
  maxRows,
  setMaxRows,
  totalRows,
}: Props) {
  if (totalRows > maxRows) {
    return (
      <Container verticalCenter horizontalCenter className={'p-4'}>
        <SmallButton appearance={'default'} onClick={setMaxRows}>
          {translate('Load More')}
        </SmallButton>
      </Container>
    );
  }

  return null;
}
